import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="app-error">
      <h1>Page not found</h1>
      <p>The page you&apos;re looking for doesn&apos;t exist or has been moved.</p>
      <Link to="/" className="button">
        Go to home
      </Link>
    </div>
  );
};

export default NotFound;
